import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import DialogDefinition from '../../../models/DialogDefinition';

const initialState: DialogDefinition = {
 height: 0,
 width: 0,
};

export const dialogSmsComponentSlice = createSlice({
 name: 'dialogSmsComponent',
 initialState,
 reducers: {
  dialogSmsComponent: (state, action: PayloadAction<DialogDefinition>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { dialogSmsComponent } = dialogSmsComponentSlice.actions;

export default dialogSmsComponentSlice.reducer;
